import { Icon, mergeStyleSets, Panel, PanelType } from "office-ui-fabric-react";
import React, { useState } from "react";
import { connect } from "react-redux";
import { TruckNomination } from "../../models";
import { State } from "../../store";
import * as GeneralStore from "../../store/GeneralStore";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import * as ActivityLogsStore from "../../store/ActivityLogsStore";
import * as SofViewStore from "../../store/SofViewStore";
import FileUpload from "./common/FIleUpload";
import NominationPanel from "./nomination/NominationPanel";
import { SofView } from "../../models/SofView";

type Props = TruckNominationStore.TruckNominationState &
    GeneralStore.GeneralState &
    ActivityLogsStore.ActivityLogsState &
    typeof TruckNominationStore.actionCreators &
    typeof SofViewStore.actionCreators
    ;

const classes = mergeStyleSets({
  viewButtonUpload: {
    width: "39px",
    height: "39px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "block",
    padding: "0",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewIconUpload: {
    color: "#4C4C4C",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    textAlign: "center",
  },
});

const AttachmentModal: React.FC<Props> = (props: Props) => {
    const [isOpenAttachment, setIsOpenAttachment] = useState(false);
    const [selTransferType, setSelTransferType] = useState("Loading");
    const { truckNomination, isVerifyInformationModal } = props;

    const onNominationEdit = (nom: TruckNomination) => {
        const { truckNomination } = props;
        if (truckNomination.result) {
            props.setTruckNomination(nom);
        }
    };
    const onTransferTypeChange = (transferType: string) => {
        setSelTransferType(transferType);

        if (props.truckNomination.result) {
            const activeTransferType =
                props.truckNomination.result &&
                props.truckNomination.result.transferType === transferType;

            if (activeTransferType) {
                setSelTransferType(transferType);
            }
        }
    };
  return (
    <>
          {!truckNomination.isLoading && truckNomination.result && (
          
          <div>
              <div
                  style={{
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                  } }
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsOpenAttachment(true);
            }}>
                      <div style={{
                          height: 48, width: 48, padding: 12,
                          borderRadius: '50%',
                          background: '#F3F4F6',
}} >
                          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M309-621q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm0 171q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm0 171q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h462l198 198v462q0 24-18 42t-42 18H180Zm0-60h600v-428.571H609V-780H180v600Zm0-600v171.429V-780v600-600Z" /></svg>
                  </div>
        </div>
                  <div style={{
                      fontSize: 12,
                          textAlign: "center" }}> Details</div>
                  </div>
      )}
      {isOpenAttachment && (
        <Panel
          isLightDismiss
          isOpen={isOpenAttachment}
                  onDismiss={() => setIsOpenAttachment(false)}
                  headerText={`${truckNomination.result?.nominationNo} Details` }
          closeButtonAriaLabel="Close"
                  type={PanelType.medium}
          layerProps={{ eventBubblingEnabled: true }}
          styles={{
            scrollableContent: { overflow: "visible" },
            content: { overflow: "visible" },
          }}
              >
                  <div style={{ height: 'calc(100vh - 150px)' }}>
                  {truckNomination.result && (
                      <NominationPanel
                          lineHandlingStatus={truckNomination.result.status}
                          isLineHandlingRejected={truckNomination.result.isRejected}
                          nomination={truckNomination.result}
                          isEditActivityAllowed={props.isTruckEditActivityAllowed}
                          isAddCommentAllowed={props.isTruckAddCommentAllowed}
                          isDeleteCommentAllowed={props.isTruckDeleteCommentAllowed}
                          isOffline={props.isOffline}
                          isApproved={false}
                          onNominationEditStart={() =>
                              props.setSofView(SofView.NominationEdit)
                          }
                          onNominationEditEnd={() =>
                              props.setSofView(SofView.Nomination)
                          }
                          onNominationEdit={onNominationEdit}
                          setTruckNomination={props.setTruckNomination}
                          activityLog={props.activityLogs}
                          selTransferType={selTransferType}
                          isVerifyInformationModal={isVerifyInformationModal}
                          isApproveRejectionAllowed={
                              props.isTruckApproveRejectionAllowed
                          }
                      />

                      )}</div>
        </Panel>
      )}
    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general,
        ...state.truckNomination,
        ...state.activityLogs,

        ...state.sofView
  }),
    {
        ...SofViewStore.actionCreators,
        ...TruckNominationStore.actionCreators,
    }
)(AttachmentModal as any);
